<template>
  <ContactList/>
</template>

<script>
import ContactList from '@/components/Contacts/ContactList.vue';

export default {
  components: {
    ContactList,
  },
};
</script>
